<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Move Container</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave" v-if="dataForm">


          <md-field :class="getValidationClass('dataForm.toBookingNo')">
            <label>Booking No</label>
            <md-input v-model="dataForm.toBookingNo"/>
            <span class="md-error" v-if="!$v.dataForm.toBookingNo.required">Booking No is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.toPoNo')">
            <label>Po No</label>
            <md-input v-model="dataForm.toPoNo"/>
            <span class="md-error" v-if="!$v.dataForm.toPoNo.required">PO No is required</span>
          </md-field>

          <calling-api path="/api/w/users/me">
            <div :class="getValidationClass('dataForm.toPickUpLocationId')">

              <autocomplete-ccic-location-select
                  v-if="getUserProfile.ccicSupplierGroup"
                  label="Pickup Location"
                  :group="getUserProfile.ccicSupplierGroup"
                  v-model="dataForm.toPickUpLocationId"
                  :on-item-selected="handlePickLocationChanged"
              />
              <md-content v-else class="md-accent">
                User does not have 'CCIC Group', please set it before creating application.
              </md-content>
              <span class="md-error" v-if="!$v.dataForm.toPickUpLocationId.required">Pickup Location is required</span>
            </div>
          </calling-api>

          <div v-if="dataForm.pickUpLocation">
            <div>{{dataForm.pickUpLocation.tagName}}</div>
            <div>
              {{dataForm.pickUpLocation.yardPostalCode}} {{dataForm.pickUpLocation.yardRegion}} {{dataForm.pickUpLocation.yardCity}}
              {{dataForm.pickUpLocation.yardStreet}}
            </div>
          </div>

          <calling-api type="bar" path="/api/w/ccic/container/move">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";

  const getInitialDataForm = () => ({
    fromUser: null,
    fromApplicationSeqNo: null,
    containerUser: null,
    containerSeqNo: null,
    toUser: null,
    toPoNo: null,
    toBookingNo: null,
    toPickUpLocationId: null,
    pickUpLocation: null,
  });


  export default {
    components: {
      AutocompleteCcicLocationSelect,
    },
    mixins: [validationMixin],
    data: () => ({
      showDialog: false,
      application: null,
      dataForm: getInitialDataForm(),
    }),
    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getUserProfile',
      ]),
      getPickupLocationOptions() {
        const { ccicSupplierGroup } = this.getUserProfile;
        if (ccicSupplierGroup) {
          return this.getMasterDataAsSelectOptionByGroup(ccicSupplierGroup);
        }
        return [];
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          this.$store.commit('clearApiError');
        }
      },
    },
    validations: {
      dataForm: {
        toPoNo: {
          required,
        },
        toBookingNo: {
          required,
        },
        toPickUpLocationId: {
          required,
        },
      },
    },
    methods: {
      handlePickLocationChanged(item) {
        if (item) {
          this.dataForm.pickUpLocation = item;
        } else {
          this.dataForm.pickUpLocation = null;
          this.dataForm.toPickUpLocationId = null;
        }
      },
      openDialog(container) {
        this.dataForm = getInitialDataForm();
        this.dataForm.fromUser = container.application.user;
        this.dataForm.fromApplicationSeqNo = container.application.seqNo;
        this.dataForm.containerUser = container.user;
        this.dataForm.containerSeqNo = container.seqNo;
        this.dataForm.toUser = container.application.user;

        this.$v.dataForm.$reset();
        this.showDialog = true;
        this.$store.dispatch('refreshUserProfile');
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();
        console.log(this.$v.dataForm.$invalid);
        if (this.$v.dataForm.$invalid) {
          return;
        }

        console.log(JSON.stringify(this.dataForm));

        //api.post("/api/w/ccic/container/move", this.dataForm)
        newAPIPost("/api/w/ccic/container/move", this.dataForm)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            $('.btn-search-ccic-container')
              .click();
          });
      },
    },
  };


</script>
